



import Page from '../PostSales/sale/PostSaleList.vue'
export default {
  name: 'postsalelistOEM',
  components: { Page },
}
